// Gives every <iframe> an accessible name. Embeds pasted into CMS content (maps, video, audio)
// usually arrive without a title, which fails WCAG 4.1.2 / axe "frame-title". Existing titles are never changed.
const LABELS = [
  [/google\.[a-z.]+\/maps|maps\.google|gmap/i, 'Map'],
  [/spotify\.com/i, 'Spotify player'],
  [/youtube(-nocookie)?\.com|youtu\.be/i, 'YouTube video'],
  [/vimeo\.com/i, 'Vimeo video'],
  [/facebook\.com/i, 'Facebook video'],
  [/instagram\.com/i, 'Instagram post'],
  [/soundcloud\.com/i, 'SoundCloud player'],
];

function titleFor(frame) {
  const src = frame.getAttribute('src') || frame.dataset.src || '';
  for (const [pattern, label] of LABELS) {
    if (pattern.test(src) || pattern.test(frame.className)) return label;
  }
  try {
    return `Embedded content from ${new URL(src, location.href).hostname.replace(/^www\./, '')}`;
  } catch {
    return 'Embedded content';
  }
}

function labelIframes(root) {
  root.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach((frame) => {
    frame.setAttribute('title', titleFor(frame));
  });
}

export function initIframeTitles() {
  labelIframes(document);
  // Embeds can be added later (Sprig/HTMX swaps, third-party embed scripts).
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IFRAME') labelIframes(node.parentNode || document);
        else if (node.querySelector && node.querySelector('iframe')) labelIframes(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
